export const BaseballIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
      <defs />
      <title>{"baseball-bat-ball"}</title>
      <circle
        cx={18.25}
        cy={17.87}
        r={2.5}
        stroke="#0f172a"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="#f8fafc"
      />
      <path
        d="M4.743,21.423,8.6,17.562,21.891,6.549a3.19,3.19,0,1,0-4.5-4.461L6.511,15.409,2.62,19.3Z"
        fill="#00e6ca"
      />
      <path
        d="M22.174,1.826,22.153,1.8a3.19,3.19,0,0,0-4.763.284L6.511,15.409,2.62,19.3,3.66,20.34Z"
        fill="#00e6ca"
      />
      <path
        d="M1.206,19.3a1,1,0,0,1,1.414,0l2.123,2.122a1,1,0,1,1-1.415,1.414L1.206,20.715A1,1,0,0,1,1.206,19.3Z"
        fill="#00e6ca"
        stroke="#0f172a"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect
        x={5.084}
        y={16.209}
        width={2.5}
        height={3.001}
        transform="translate(-10.667 9.666) rotate(-45.001)"
        fill="#00e6ca"
        stroke="#0f172a"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.743,21.423,8.6,17.562,21.891,6.549a3.19,3.19,0,1,0-4.5-4.461L6.511,15.409,2.62,19.3Z"
        fill="none"
        stroke="#0f172a"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
